import { render, staticRenderFns } from "./AlertRecordForm.vue?vue&type=template&id=f202d210&"
import script from "./AlertRecordForm.vue?vue&type=script&lang=js&"
export * from "./AlertRecordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports